import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MobilityMapSvg } from "./MobilityMapSvg";
import { NIA_TRANSPORT } from "../data/site";
import { scrollToId } from "./shared";

function useCyclingMode() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % NIA_TRANSPORT.length), 1400);
    return () => clearInterval(t);
  }, []);
  return NIA_TRANSPORT[idx];
}

export function HeroMapSlide() {
  const mode = useCyclingMode();
  return (
    <div className="absolute inset-0 bg-[#0A0A0A]" data-testid="hero-map-slide">
      <div className="absolute inset-y-0 right-0 w-full lg:w-auto lg:left-[48%] lg:right-[3%] flex items-center justify-center opacity-50 lg:opacity-95 lg:translate-y-[2%]">
        <MobilityMapSvg active={mode.id} filterId="glowHero" showLabels className="w-full h-auto scale-[1.15] lg:scale-100 lg:w-auto lg:h-[50vh] lg:max-w-full" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/85 to-transparent lg:via-[#0A0A0A]/40" />
    </div>
  );
}

export function HeroMapCta() {
  const mode = useCyclingMode();
  return (
    <>
      <button
        type="button"
        onClick={() => scrollToId("airport-mobility")}
        data-testid="hero-map-slide-cta"
        className="hidden lg:flex absolute lg:bottom-36 right-5 lg:right-8 z-10 group items-center gap-3 pl-4 pr-3 py-2.5 border border-[#D4AF37]/40 bg-black/60 backdrop-blur-md rounded-full text-left hover:border-[#D4AF37] transition-colors"
      >
        <span>
          <span className="block text-[9px] uppercase tracking-[0.25em] text-[#D4AF37]">New &middot; Airport transport map</span>
          <motion.span key={mode.id} initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} className="block text-[11px] text-[#F5F5F0]" data-testid="hero-map-slide-mode">
            {mode.mode} &middot; {mode.stat}
          </motion.span>
        </span>
        <span className="w-8 h-8 grid place-items-center rounded-full bg-gradient-to-r from-[#C5A059] to-[#D4AF37] text-black group-hover:from-[#D4AF37] group-hover:to-[#F3E5AB] transition-colors"><ArrowRight size={14} /></span>
      </button>
    </>
  );
}
